export default "__VITE_ASSET__cE1tqkXe__"